"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("regenerator-runtime/runtime");

var _axios = _interopRequireDefault(require("axios"));

var _ebookUtils = require("./ebook-utils");

var getOrderData = function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(customerUrl) {
    var response, parser, doc, arrEbooks;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _axios["default"].get(customerUrl);

          case 3:
            response = _context.sent;
            parser = new DOMParser();
            doc = parser.parseFromString(response.data, 'text/html');
            arrEbooks = JSON.parse(doc.getElementById('ebooks-data').textContent);

            if (!(arrEbooks.ebooks.length === 0)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", true);

          case 9:
            data = [].concat(_toConsumableArray(data), _toConsumableArray(arrEbooks.ebooks));
            return _context.abrupt("return", true);

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", "order.customerUrl not found ".concat(customerUrl));

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 13]]);
  }));

  return function getOrderData(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getOrderDataWrapper = function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(customerUrl) {
    var attempts, response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            attempts = 0;

          case 1:
            attempts++;
            _context2.next = 4;
            return getOrderData(customerUrl);

          case 4:
            response = _context2.sent;

          case 5:
            if (attempts < 20 && response !== true) {
              _context2.next = 1;
              break;
            }

          case 6:
            if (!(response !== true)) {
              _context2.next = 9;
              break;
            }

            window.console.log('customer URL not found', customerUrl);
            return _context2.abrupt("return", Promise.reject(new Error(response)));

          case 9:
            return _context2.abrupt("return", Promise.resolve());

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getOrderDataWrapper(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var getOrderTokens = function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3() {
    var customerAccessToken, query, vars, ret, response;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            customerAccessToken = window.localStorage.getItem('mb-customer-access-token');
            query = _ebookUtils.ebooksOrderQuery;
            vars = {
              cursor: null,
              customerAccessToken: customerAccessToken,
              count: 20,
              edges: ['customer', 'orders']
            };
            ret = {
              data: []
            };
            _context3.next = 6;
            return (0, _ebookUtils.paginateAll)(query, vars, ret, setProgress);

          case 6:
            response = _context3.sent;
            response = response.map(function (res) {
              return res.node.customerUrl;
            });
            return _context3.abrupt("return", response);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getOrderTokens() {
    return _ref3.apply(this, arguments);
  };
}();

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var progressBar = document.getElementById('progressBar');
var data = []; // 3 hour ttl

var cacheTtlMilliseconds = 60000 * 60 * 3;

function setCache(key, value, ttl) {
  var now = new Date();
  var item = {
    value: value,
    expiry: now.getTime() + ttl
  };
  window.localStorage.setItem(key, JSON.stringify(item));
}

function getCache(key) {
  var itemStr = window.localStorage.getItem(key); // if the item doesn't exist, return null

  if (!itemStr) {
    return null;
  }

  var item = JSON.parse(itemStr);
  var now = new Date(); // compare the expiry time of the item with the current time

  if (now.getTime() > item.expiry) {
    window.console.log('key expired', key); // If the item is expired, delete the item from storage
    // and return null

    window.localStorage.removeItem(key);
    return null;
  }

  return JSON.parse(item.value);
}

function setProgress(stage, percentage) {
  var width = 0;
  var progress = '';
  var display = 'block';
  width = percentage;
  progress = "".concat(Math.ceil(percentage), "%");

  if (stage === 1 && percentage > 10) {
    width = 10;
    progress = '10%';
  }

  if (stage === 2 && percentage >= 100) {
    width = 100;
    progress = '100%';
    display = 'none';
  }

  progressBar.style.display = display;
  progressBar.style.width = "".concat(width, "%");
  progressBar.innerHTML = progress;
}

var _default = function _default() {
  var init = function () {
    var _ref4 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4() {
      var progress, customerUrls, customerAccessToken, customerEmail, customerUrlsCount, ebooksCache, pageSize, steps, index;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              progress = 0;
              setProgress(1, progress); // Get the customerUrls all customer.orders

              _context4.next = 4;
              return getOrderTokens();

            case 4:
              customerUrls = _context4.sent;
              progress = 10;
              setProgress(1, progress); // Get customer access token

              customerAccessToken = window.localStorage.getItem('mb-customer-access-token'); // Get cached customer email

              customerEmail = window.localStorage.getItem(customerAccessToken); // Get the cached order count

              customerUrlsCount = getCache("mb-".concat(customerEmail, "-urls-count")); // Compare cached and latest order count, if the same then retrieve and return cache

              if (!customerUrlsCount) {
                _context4.next = 16;
                break;
              }

              if (!(customerUrls.length === customerUrlsCount)) {
                _context4.next = 16;
                break;
              }

              ebooksCache = getCache("mb-".concat(customerEmail, "-ebooks"));

              if (!ebooksCache) {
                _context4.next = 16;
                break;
              }

              setProgress(2, 100);
              return _context4.abrupt("return", ebooksCache);

            case 16:
              // Scrape order detail data from customer order page with customerUrl
              // for (let index = 0; index < customerUrls.length; index += 100) {
              pageSize = 40;
              steps = 90 / Math.ceil(customerUrls.length / pageSize);
              index = 0;

            case 19:
              if (!(index < customerUrls.length)) {
                _context4.next = 27;
                break;
              }

              _context4.next = 22;
              return Promise.all(customerUrls.slice(index, index + pageSize).map(function (customerUrl) {
                return getOrderDataWrapper(customerUrl);
              }));

            case 22:
              progress += steps;
              setProgress(2, progress);

            case 24:
              index += pageSize;
              _context4.next = 19;
              break;

            case 27:
              // Sort the data by most recent orders
              data.sort(function (objA, objB) {
                return new Date(objB.createdAt.replace(/-/g, '/')) - new Date(objA.createdAt.replace(/-/g, '/'));
              }); // Set order count and ebooks data in localStorage

              setCache("mb-".concat(customerEmail, "-ebooks"), JSON.stringify(data), cacheTtlMilliseconds);
              setCache("mb-".concat(customerEmail, "-urls-count"), JSON.stringify(customerUrls.length), cacheTtlMilliseconds);
              return _context4.abrupt("return", data);

            case 31:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function init() {
      return _ref4.apply(this, arguments);
    };
  }();

  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;